export const CLOUD_RUN_URL = 'https://blockjo-backend-481250886635.us-central1.run.app';

export function isCloudStorage () {
    if (typeof window === 'undefined') return false;
    const hostname = window.location.hostname;
    return hostname === 'storage.googleapis.com' || hostname.endsWith('.storage.googleapis.com');
}

export function getApiBase () {
    if (isCloudStorage()) {
        return CLOUD_RUN_URL;
    }
    return '';
}

export function apiUrl (path) {
    const base = getApiBase();
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${base}${cleanPath}`;
}

export function getWsUrl (path) {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    if (isCloudStorage() || (typeof window !== 'undefined' && (window.location.hostname.endsWith('.web.app') || window.location.hostname.endsWith('.firebaseapp.com')))) {
        return `wss://blockjo-backend-481250886635.us-central1.run.app${cleanPath}`;
    }
    const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = typeof window !== 'undefined' ? window.location.host : 'localhost:5000';
    return `${protocol}//${host}${cleanPath}`;
}
